module.exports = __webpack_public_path__ + "img/icon-sub-task-18.3555f0b7.svg";